const isNonEmptyValue = (value, clearNulls) => value !== '' && value !== undefined && (clearNulls ? value !== null : true);
function filterEmptyProps(clearNulls) {
  return function _filterEmptyProps(obj) {
    if (typeof obj === 'object' && obj !== null) {
      return Object.keys(obj).reduce((newObj, prop) => {
        const value = obj[prop];
        if (isNonEmptyValue(value, clearNulls)) {
          return {
            ...newObj,
            [prop]: value
          };
        }
        return newObj;
      }, {});
    }
    return obj;
  };
}

/**
 * Removes empty string, null and undefined entries from object.
 *
 * This doesn't traverse nested props. May need to add in future.
 */
function withoutEmptyProps(data, clearNulls = false) {
  if (Array.isArray(data)) {
    return data.map(filterEmptyProps(clearNulls));
  }
  return filterEmptyProps(clearNulls)(data);
}
export default withoutEmptyProps;